var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dsafsa"},[_c('div',{key:_vm.echarkey,ref:"main",staticStyle:{"width":"1600px","height":"400px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }